import React from 'react';
import { useTranslation } from 'react-i18next';
import Seo from '../../components/Seo';
import { getStaticMeta } from '../../seo/pageMeta';

const CookiePolicyScreen = () => {
  const { t, i18n } = useTranslation();
  const meta = getStaticMeta('cookies', i18n.language);

  return (
    <div className="min-h-screen bg-bg pt-28 pb-24 md:pt-32">
      <Seo title={meta.title} description={meta.description} path="/cookies" />
      <div className="mx-auto max-w-page px-6">
        <article className="max-w-3xl mx-auto prose prose-invert prose-headings:text-body prose-a:text-primary prose-p:text-muted prose-li:text-muted">
          <h1>{t('legal.cookiePolicy.title')}</h1>
          <p className="text-sm !text-muted">
            {t('legal.cookiePolicy.lastUpdated')}
          </p>

          <section>
            <h2>{t('legal.cookiePolicy.sections.introduction.title')}</h2>
            <p>{t('legal.cookiePolicy.sections.introduction.content1')}</p>
            <p>{t('legal.cookiePolicy.sections.introduction.content2')}</p>
          </section>

          <section>
            <h2>{t('legal.cookiePolicy.sections.whatAreCookies.title')}</h2>
            <p>{t('legal.cookiePolicy.sections.whatAreCookies.content')}</p>
          </section>

          <section>
            <h2>{t('legal.cookiePolicy.sections.howWeUseCookies.title')}</h2>
            <p>{t('legal.cookiePolicy.sections.howWeUseCookies.content')}</p>
            <ul>
              <li><strong className="text-body">{t('legal.cookiePolicy.sections.howWeUseCookies.types.essential.title')}</strong> : {t('legal.cookiePolicy.sections.howWeUseCookies.types.essential.description')}</li>
              <li><strong className="text-body">{t('legal.cookiePolicy.sections.howWeUseCookies.types.performance.title')}</strong> : {t('legal.cookiePolicy.sections.howWeUseCookies.types.performance.description')}</li>
              <li><strong className="text-body">{t('legal.cookiePolicy.sections.howWeUseCookies.types.functionality.title')}</strong> : {t('legal.cookiePolicy.sections.howWeUseCookies.types.functionality.description')}</li>
              <li><strong className="text-body">{t('legal.cookiePolicy.sections.howWeUseCookies.types.targeting.title')}</strong> : {t('legal.cookiePolicy.sections.howWeUseCookies.types.targeting.description')}</li>
            </ul>
          </section>

          <section>
            <h2>{t('legal.cookiePolicy.sections.thirdPartyCookies.title')}</h2>
            <p>{t('legal.cookiePolicy.sections.thirdPartyCookies.content')}</p>
            <ul>
              <li><strong className="text-body">Google Analytics</strong> : {t('legal.cookiePolicy.sections.thirdPartyCookies.services.googleAnalytics')}</li>
              <li><strong className="text-body">Stripe</strong> : {t('legal.cookiePolicy.sections.thirdPartyCookies.services.stripe')}</li>
            </ul>
          </section>

          <section>
            <h2>{t('legal.cookiePolicy.sections.manageCookies.title')}</h2>
            <p>{t('legal.cookiePolicy.sections.manageCookies.content1')}</p>
            <p>{t('legal.cookiePolicy.sections.manageCookies.content2')}</p>
            <ul>
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a></li>
              <li><a href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies" target="_blank" rel="noopener noreferrer">Firefox</a></li>
              <li><a href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Edge</a></li>
              <li><a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
            </ul>
          </section>

          <section>
            <h2>{t('legal.cookiePolicy.sections.updates.title')}</h2>
            <p>{t('legal.cookiePolicy.sections.updates.content')}</p>
          </section>

          <section>
            <h2>{t('legal.cookiePolicy.sections.contact.title')}</h2>
            <p>{t('legal.cookiePolicy.sections.contact.content')}</p>
            <ul>
              <li>{t('legal.cookiePolicy.sections.contact.email')}</li>
              <li>{t('legal.cookiePolicy.sections.contact.address')}</li>
              <li>{t('legal.cookiePolicy.sections.contact.phone')}</li>
            </ul>
          </section>
        </article>
      </div>
    </div>
  );
};

export default CookiePolicyScreen;
